import { startAuthentication, startRegistration, browserSupportsWebAuthn } from '@simplewebauthn/browser';

const BASE = '/passkey';

export const isPasskeySupported = (): boolean => browserSupportsWebAuthn();

// ─── Authentication ────────────────────────────────────────────────────────

export const loginWithPasskey = async (): Promise<{ redirectTo: string }> => {
    const options = await fetch(`${BASE}/authenticate/options`, {
        method: 'POST',
        credentials: 'include',
    }).then((r) => r.json());

    // Браузер показывает диалог выбора passkey (Face ID, Touch ID, Windows Hello)
    const credential = await startAuthentication(options);

    return fetch(`${BASE}/authenticate/verify`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(credential),
    }).then((r) => r.json());
};

// ─── Registration ──────────────────────────────────────────────────────────

export const registerPasskey = async (deviceName?: string): Promise<void> => {
    const options = await fetch(`${BASE}/register/options`, {
        method: 'POST',
        credentials: 'include',
    }).then((r) => r.json());

    // Браузер показывает диалог создания passkey
    const credential = await startRegistration(options);

    await fetch(`${BASE}/register/verify`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...credential, deviceName }),
    }).then((r) => r.json());
};
